import { ref, computed } from 'vue';
import { acceptHMRUpdate, defineStore } from 'pinia';
import { pauseBilling, resumeBilling, resumeBillingApi, pauseAllfee, resumeAllfee } from '@/requestPub/interface.js';
import { TABLE_VIEW_TYPE } from '@/constants/table.js';
import { partialSettlementPay } from '@/requestPub/refundApi.js';
export const useDoorStore = defineStore('door', () => {
    // 当前点击的桌台信息
    const tableInfo = ref(null);

    // 设置当前点击的桌台信息
    const setTableInfo = (info) => {
        tableInfo.value = info;
    };

    //当前点击要查看的用户信息
    const lookDoorUserInfo = ref(null);
    const lookOrderUserInfo = ref(null);
    const lookMoreUserInfo = ref(null);

    // 设置当前点击要查看的用户信息 缺分是桌台、零售、更多
    const setLookUserInfo = (user, type) => {
        if (type === 'table') {
            lookDoorUserInfo.value = user;
        } else if (type === 'order') {
            lookOrderUserInfo.value = user;
        } else {
            lookMoreUserInfo.value = user;
        }
    };
    // 会员充值预充订单
    const preDoorChargeOrder = ref(null);
    const preOrderChargeOrder = ref(null);
    const preChargeChargeOrder = ref(null);
    // 设置会员充值预充订单
    const setPreChargeOrder = (order, sourceType) => {
        if (sourceType === 'table') {
            preDoorChargeOrder.value = order;
        } else if (sourceType === 'order') {
            preOrderChargeOrder.value = order;
        } else {
            preChargeChargeOrder.value = order;
        }
    };
    // 当前桌台切换的类型
    const tableType = ref('index');
    // 当前支付方式
    const payType = ref('');
    // 设置当前支付
    const setPayType = (type) => {
        payType.value = type;
    };
    // 设置当前切换的类型
    const setTableType = (type) => {
        tableType.value = type;
        // 如果是首页,则清空桌台信息
        if (type === TABLE_VIEW_TYPE.INDEX) {
            tableInfo.value = null;
        }
        // 如果是返回结账页面,则清空支付类型
        setPayType('');
        // 如果是返回结账页面,则清空自选购物项支付
        setAutoChooiseBoo(false);
        clearBillChooiseCard();
    };

    // 当前支付详情
    const payDoorDetail = ref(null);
    const payOrderDetail = ref(null);
    const payChargeDetail = ref(null);
    // 设置当前支付详情
    const setPayDetail = (detail, sourceType) => {
        if (sourceType === 'order') {
            payOrderDetail.value = detail;
        } else if (sourceType === 'table') {
            payDoorDetail.value = detail;
        } else {
            payChargeDetail.value = detail;
        }
    };
    // 暂停计费
    const pauseBillingFun = async (tableId) => {
        return await pauseBilling({ id: tableId });
    };
    // 暂停所有计费
    const pauseAllBillingFun = async (bill_id) => {
        return await pauseAllfee({ bill_id });
    };
    // 恢复所有计费
    const resumeAllBillingFun = async (bill_id) => {
        return await resumeAllfee({ bill_id });
    };
    // 恢复计费
    const resumeBillingFun = async (tableId) => {
        return await resumeBilling({ id: tableId });
    };
    // 自选购物项开启状态
    const autoChooiseBoo = ref(false);
    // 设置自选购物项支付
    const setAutoChooiseBoo = (boo) => {
        autoChooiseBoo.value = boo;
    };
    // 选中的商品
    const billChooiseCardList = ref([]);
    const billChooiseCardCountAmout = computed(() => {
        if (!billChooiseCardList.value.length) {
            return 0;
        }
        let countAmout = billChooiseCardList.value.reduce((pre, cur) => pre + Number(cur?.item?.amount || cur?.item?.total_amount || 0), 0);
        return countAmout.toFixed(2);
    });
    // 清空选中的商品
    const clearBillChooiseCard = () => {
        billChooiseCardList.value = [];
    };
    // 设置选中的商品
    const setBillChooiseCard = (params) => {
        const nIndex = billChooiseCardList.value.findIndex((e) => e?.item.id == params?.item.id && e?.cardKey == params?.cardKey);
        if (nIndex == -1) {
            billChooiseCardList.value.push(params);
        } else {
            billChooiseCardList.value.splice(nIndex, 1);
        }
    };

    /**
     * 部分结账
     * @param {参数} params
     * @param {需否直接返回结果} boo
     * @returns
     */
    const partialSettlementPayFun = async (params, boo = false) => {
        let orderObject = {};
        billChooiseCardList.value.forEach((e) => {
            if (orderObject[e.cardKey]) {
                orderObject[e.cardKey].push(e?.item?.id);
            } else {
                orderObject[e.cardKey] = [e?.item?.id];
            }
        });
        const query = {
            ...params,
            room_order_id: tableInfo.value.order_id,
            amount: billChooiseCardCountAmout.value,
            orders: orderObject
        };
        const ret = await partialSettlementPay(query);
        if (boo) {
            return ret;
        } else {
            if (ret.code == 200) {
                billChooiseCardList.value = [];
                return true;
            }
        }
    };

    //重置显示状态
    const resetDoorFun = (billId = '') => {
        if (tableType.value == TABLE_VIEW_TYPE.INDEX) {
            uni.$emit('resetDoorFun');
        } else if (tableInfo.value?.order_id == billId) {
            setTableType(TABLE_VIEW_TYPE.INDEX);
        }
    };

    // 恢复结账计费
    const resestoreBillingFun = async (params) => {
        const ret = await resumeBillingApi(params);
        if (ret.code == 200) {
            return true;
        }
        return false;
    };
    return {
        tableInfo,
        setTableInfo,

        lookDoorUserInfo,
        lookOrderUserInfo,
        lookMoreUserInfo,
        setLookUserInfo,

        tableType,
        setTableType,
        payType,
        setPayType,
        pauseBillingFun,
        resumeAllBillingFun,
        pauseAllBillingFun,
        resumeBillingFun,
        preDoorChargeOrder,
        preOrderChargeOrder,
        preChargeChargeOrder,
        setPreChargeOrder,

        // 当前支付详情
        payDoorDetail,
        payOrderDetail,
        payChargeDetail,
        setPayDetail,

        // 自选购物项支付
        autoChooiseBoo,
        setAutoChooiseBoo,

        // 选中的商品
        billChooiseCardList,
        setBillChooiseCard,
        billChooiseCardCountAmout,
        clearBillChooiseCard,

        //部分结账
        partialSettlementPayFun,

        //重置显示状态
        resetDoorFun,

        // 恢复计费
        resestoreBillingFun
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useDoorStore, import.meta.hot));
}
